// // program accordeon

function collapseProgramItem(item){
    item.classList.remove("active"); 
    item.style.height = getComputedStyle(item).height; // eslint-disable-line no-param-reassign
    item.offsetHeight // eslint-disable-line no-unused-expressions
    item.style.height = '180px'; // eslint-disable-line no-param-reassign
  }
  

document.addEventListener('click', function(e){

  if (e.target.closest('.program_item')&&(!e.target.classList.contains('wishlist'))){
    
    const programItems = document.querySelectorAll('.program_item');
    if (programItems){

      const target = e.target.closest('.program_item');

      if (!target.classList.contains('active')){

        programItems.forEach(programItem => {
          collapseProgramItem(programItem);
        });

        target.classList.add("active");    
        const prevHeight = target.style.height;
        target.style.height = 'auto'; // eslint-disable-line no-param-reassign
        const endHeight = getComputedStyle(target).height;
        target.style.height = prevHeight; // eslint-disable-line no-param-reassign
        target.offsetHeight; // eslint-disable-line no-unused-expressions 
        target.style.height = endHeight; // eslint-disable-line no-param-reassign

      }else{
        collapseProgramItem(target);
      }

    }
  }
});
   

// //////////////////////////////////////////////////////////////////////////////////////////////